import {
  DateFieldFilter,
  DateFieldFilterOperationType,
} from 'module/types/filter-field/filter/date';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { snakeCase } from 'lodash';
import { FormattedMessage } from 'react-intl';

export const renderMenuItem = (
  type: DateFieldFilterOperationType,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | React.JSX.Element,
) => (
  <Menu.Item
    data-cy={`op.${type}`}
    key={type.toString()}
    className="date-criteria"
  >
    {getOperationOptionRenderer?.(type) ?? (
      <FormattedMessage
        id={`task_list.filters.${snakeCase(
          DateFieldFilterOperationType[type],
        )}`}
      />
    )}
  </Menu.Item>
);
